import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Hobbs = () => {
  const nearbyFacilities = [
    { name: 'Permian Basin Operations', type: 'Oil & Gas', capacity: '1,000+ Wells' },
    { name: 'Processing Plants', type: 'Gas Processing', capacity: 'Major Facilities' },
    { name: 'Production Equipment', type: 'Upstream', capacity: '200+ Sites' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Hobbs Permian Basin operations?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Hobbs Permian Basin oil and gas operations. We provide 4-6 hour response times with competitive pricing for this highly productive region."
    },
    {
      question: "What types of equipment do you buy from Hobbs production facilities?",
      answer: "We buy control valves, wellhead equipment, separators, pumps, compressors, and safety systems from Hobbs' 1,000+ production wells and processing plants. We understand the specific requirements of Permian Basin operations."
    },
    {
      question: "How quickly can you respond to Hobbs facilities?",
      answer: "We provide 4-6 hour response times for Hobbs and surrounding Permian Basin facilities. Our team has 20+ years of experience serving New Mexico's oil and gas industry including production operations and processing plants."
    },
    {
      question: "Do you purchase equipment from Hobbs gas processing plants?",
      answer: "Yes, we buy process equipment and instrumentation from Hobbs' major gas processing facilities. We provide professional valuations for gas processing equipment, control systems, and specialized Permian Basin instrumentation."
    },
    {
      question: "What valve brands do you buy from Hobbs facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Hobbs production facilities, gas processing plants, and upstream operations throughout the Permian Basin."
    },
    {
      question: "Do you buy equipment during Hobbs facility shutdowns?",
      answer: "Yes, we provide shutdown coordination for Hobbs production facilities and processing plants. We can quickly evaluate and purchase surplus equipment during planned maintenance, workovers, and facility upgrades."
    }
  ];

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://valvesalessupply.com/hobbs",
        "url": "https://valvesalessupply.com/hobbs",
        "name": "Hobbs Valve Buyers New Mexico | Permian Basin Equipment",
        "description": "Leading valve buyers in Hobbs serving Permian Basin oil & gas operations. We purchase surplus valves, control systems, and production equipment at above scrap rates. Call 214-854-5638.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "New Mexico",
              "item": "https://valvesalessupply.com/new-mexico"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Hobbs",
              "item": "https://valvesalessupply.com/hobbs"
            }
          ]
        }
      },
      {
        "@type": "LocalBusiness",
        "name": "Valve Sales Supply - Hobbs",
        "image": "https://valvesalessupply.com/logo.png",
        "@id": "https://valvesalessupply.com/hobbs",
        "url": "https://valvesalessupply.com/hobbs",
        "telephone": "214-854-5638",
        "priceRange": "$$",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Hobbs",
          "addressRegion": "NM",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 32.7026,
          "longitude": -103.1357
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "17:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "09:00",
            "closes": "14:00"
          }
        ],
        "areaServed": [
          {
            "@type": "City",
            "name": "Hobbs",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Lovington",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Jal",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          },
          {
            "@type": "City",
            "name": "Eunice",
            "containedIn": {
              "@type": "State",
              "name": "New Mexico"
            }
          }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Permian Basin Equipment Purchasing Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Permian Basin Production Equipment Purchase",
                "description": "Professional purchasing of production equipment from Hobbs' 1,000+ wells at above scrap rates"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Fisher Control Valves Purchase",
                "description": "Expert evaluation and purchase of Fisher control valves from Permian Basin operations"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Gas Processing Equipment Purchase",
                "description": "Complete purchasing services for gas processing equipment and instrumentation"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Wellhead Equipment Purchase",
                "description": "Professional equipment purchasing from Hobbs production facilities and wellhead operations"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Facility Shutdown Coordination",
                "description": "Fast response shutdown coordination for Hobbs facilities with complete compliance documentation"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Emergency Equipment Removal",
                "description": "4-6 hour response time for urgent equipment removal and purchasing in Hobbs area"
              }
            }
          ]
        }
      },
      {
        "@type": "Service",
        "serviceType": "Permian Basin Oil & Gas Equipment Purchasing",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Hobbs"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Hobbs"
          },
          {
            "@type": "City",
            "name": "Lovington"
          },
          {
            "@type": "City",
            "name": "Jal"
          },
          {
            "@type": "City",
            "name": "Eunice"
          },
          {
            "@type": "City",
            "name": "Artesia"
          }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Equipment Categories",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Fisher Control Valves",
                "description": "Fisher control valves, regulators, and actuators from Hobbs production facilities"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Production Equipment",
                "description": "Wellhead equipment, separators, pumps, and compressors from Permian Basin"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Rosemount Instrumentation",
                "description": "Rosemount transmitters, flow meters, pressure instruments, and safety systems"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Product",
                "name": "Gas Processing Equipment",
                "description": "Gas processing equipment and specialized instrumentation from Hobbs facilities"
              }
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": faqData.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }
    ]
  };

  useEffect(() => {
    // Set page title
    document.title = "Hobbs Valve Buyers New Mexico | Permian Basin Equipment";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Leading valve buyers in Hobbs serving Permian Basin oil & gas operations. We purchase surplus valves, control systems, and production equipment at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Leading valve buyers in Hobbs serving Permian Basin oil & gas operations. We purchase surplus valves, control systems, and production equipment at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers Hobbs, Permian Basin equipment, New Mexico surplus valves, Fisher control valves, oil gas production');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'valve buyers Hobbs, Permian Basin equipment, New Mexico surplus valves, Fisher control valves, oil gas production';
      document.head.appendChild(meta);
    }

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/hobbs');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Hobbs Valve Buyers New Mexico | Permian Basin Equipment' },
      { property: 'og:description', content: 'Leading valve buyers in Hobbs serving Permian Basin oil & gas operations.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/hobbs' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '32.7026;-103.1357' },
      { name: 'geo.placename', content: 'Hobbs, New Mexico' },
      { name: 'geo.region', content: 'US-NM' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(schemaData)) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/a680485f615d806b6528730c270b6e6e.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Hobbs</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers in Hobbs</strong> serving the Permian Basin oil and gas operations. 
              Valve Sales Supply purchases surplus valves, control systems, and instrumentation from Hobbs production 
              facilities and processing plants at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET HOBBS QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">HOBBS PERMIAN BASIN EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Hobbs is at the heart of the Permian Basin, one of America's most productive oil and gas regions. 
                As experienced <strong className="text-[#1B3A5F]">surplus valve buyers in Hobbs</strong>, 
                we provide professional equipment purchasing services for production facilities and processing plants.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount transmitters, and complete instrumentation systems from Hobbs oil and gas operations.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">1,000+</div>
                  <div className="text-gray-600">Production Wells</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">4-6 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">200+</div>
                  <div className="text-gray-600">Production Sites</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">HOBBS FACILITIES</h3>
              <div className="space-y-4">
                {nearbyFacilities.map((facility, index) => (
                  <div key={index} className="bg-white rounded-lg p-4">
                    <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                    <div className="flex justify-between mt-2">
                      <span className="text-gray-600 text-sm">{facility.type}</span>
                      <span className="text-[#1B3A5F] font-semibold text-sm">{facility.capacity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES HOBBS NM</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Hobbs Permian Basin facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Control Valves',
                equipment: ['Fisher Control Valves', 'Masoneilan Valves', 'Ball Valves', 'Gate Valves', 'Check Valves'],
                description: 'Premium control valves from Hobbs production facilities'
              },
              {
                title: 'Production Equipment',
                equipment: ['Wellhead Equipment', 'Separators', 'Pumps', 'Compressors'],
                description: 'Oil & gas production equipment from Permian Basin'
              },
              {
                title: 'Instrumentation',
                equipment: ['Rosemount Transmitters', 'Flow Meters', 'Pressure Instruments', 'Safety Systems'],
                description: 'Process instrumentation from New Mexico facilities'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{category.title}</h3>
                <p className="text-gray-600 mb-6">{category.description}</p>
                
                <div className="space-y-3">
                  {category.equipment.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">RELATED PERMIAN BASIN MARKETS</h2>
            <p className="text-gray-600 text-xl">We serve all major Permian Basin industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { city: 'Artesia', link: '/artesia', state: 'NM' },
              { city: 'Roswell', link: '/roswell', state: 'NM' },
              { city: 'Midland', link: '/midland', state: 'TX' },
              { city: 'Odessa', link: '/odessa', state: 'TX' }
            ].map((market, index) => (
              <Link
                key={index}
                to={market.link}
                className="bg-[#F5F7FA] rounded-xl p-6 text-center hover:shadow-lg hover:bg-white transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
              >
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{market.city}</h3>
                <div className="text-gray-600 text-sm mb-3">{market.state} Valve Buyers</div>
                <div className="text-[#1B3A5F] font-semibold inline-flex items-center">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/new-mexico"
              className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center text-lg"
            >
              View All New Mexico Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">HOBBS EQUIPMENT BUYER</h2>
              <p className="text-xl text-gray-200 mb-8">
                Contact Mark Driver for professional equipment purchasing services in Hobbs
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold text-xl">214-854-5638</div>
                    <div className="text-gray-300">Direct Line - Mark Driver</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold">hobbs@valvesalessupply.com</div>
                    <div className="text-gray-300">Equipment Lists & Photos</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WHY CHOOSE VALVE SALES SUPPLY</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast 4-6 hour response in Hobbs',
                  'Expert knowledge of Permian Basin operations',
                  'Professional turnaround coordination',
                  'Complete compliance documentation',
                  '20+ years New Mexico market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] text-xl mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center w-full whitespace-nowrap"
                >
                  GET QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">HOBBS VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Hobbs;